<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

  <mat-tab label="Individual Sessions">
    <app-education-individual-table></app-education-individual-table>
  </mat-tab>

  <mat-tab label="Group Sessions">
    <app-education-group-table></app-education-group-table>
  </mat-tab>

  <mat-tab label="Report">
    <app-education-child-report></app-education-child-report>
  </mat-tab>
</mat-tab-group>



<!--Add Group Education Table Component-->
<!--Add it to Group Session Tab-->
<!--Create View Group Session Component-->
<!--Add Group Session Component to group Table View Button-->
